import { confirm } from 'helpers/confirm/confirm';

export const SLOT_POPUP = 'msa-popUp';
export const SLOT_SIDEBAR = 'msa-sidebar';
export const SLOT_EXIT_PAGE = 'msa-exitPage';

const TIPI_POPUP = ['popUp', 'popUpOfferta', 'popUpProfilazione'];
const TIPI_SIDEBAR = [
    'sidebar',
    'sidebarOfferta',
    'sidebarServiziTop',
    'sidebarPreventivo',
];
const TIPI_EXIT_PAGE = ['exitPage'];
const TIPI_BANNER = ['banner', 'bannerOfferta'];

export function getSlotInterazione({ tipoComunicazione, idHtmlElement } = {}) {
    if (TIPI_POPUP.indexOf(tipoComunicazione) !== -1) {
        return SLOT_POPUP;
    }

    if (TIPI_SIDEBAR.indexOf(tipoComunicazione) !== -1) {
        return SLOT_SIDEBAR;
    }

    if (TIPI_EXIT_PAGE.indexOf(tipoComunicazione) !== -1) {
        return SLOT_EXIT_PAGE;
    }

    if (TIPI_BANNER.indexOf(tipoComunicazione) !== -1) {
        return idHtmlElement || null;
    }

    return null;
}

export function normalizzaInterazionePerSlot(item) {
    if (!item) {
        return null;
    }

    const comunicazione = item.comunicazione || {};

    return {
        id: item.id,
        titolo: item.titolo,
        tipoComunicazione:
            item.tipo_comunicazione || comunicazione.tipo_comunicazione,
        idHtmlElement:
            item.id_html_element || comunicazione.id_html_element,
    };
}

export function findConflittiStessoSlot(corrente, altre) {
    const slot = getSlotInterazione(corrente);

    if (!slot || !corrente || !corrente.id) {
        return [];
    }

    return (altre || []).filter((altra) => {
        if (!altra || altra.id === corrente.id) {
            return false;
        }

        return getSlotInterazione(altra) === slot;
    });
}

export function messaggioConflittoSlot(conflitti, contesto) {
    const nomi = (conflitti || [])
        .map((interazione) => `«${interazione.titolo}»`)
        .join(', ');
    const singolare = !conflitti || conflitti.length <= 1;
    const verbo = singolare
        ? "verrà sovrascritta l'interazione già presente"
        : 'verranno sovrascritte le interazioni già presenti';
    const prefisso =
        contesto === 'attiva'
            ? 'Mettendo online questa interazione'
            : 'Salvando le modifiche';

    return `${prefisso} ${verbo} sullo stesso contenitore: ${nomi}. Vuoi continuare?`;
}

export function chiediConfermaConflittoSlot(dispatch, conflitti, contesto) {
    if (!conflitti || !conflitti.length) {
        return Promise.resolve(true);
    }

    return new Promise((resolve) => {
        dispatch(
            confirm.actions.showConfirmDialog({
                message: messaggioConflittoSlot(conflitti, contesto),
                onSuccess: () => resolve(true),
                onCancel: () => resolve(false),
            })
        );
    });
}
